"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackSignupClickDTO = exports.PackCloseDTO = exports.PackShowOfferDTO = void 0;
const class_validator_1 = require("class-validator");
const decorators_1 = require("../decorators");
const types_1 = require("../types");
const dto_factory_1 = require("../types/dto-factory");
let PackShowOfferDTO = class PackShowOfferDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.PackShowOfferDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "path", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, decorators_1.Describe)('Offer shown to the user'),
    __metadata("design:type", String)
], PackShowOfferDTO.prototype, "path", void 0);
PackShowOfferDTO = __decorate([
    (0, decorators_1.Describe)('Offer shown to a gala user')
], PackShowOfferDTO);
exports.PackShowOfferDTO = PackShowOfferDTO;
let PackCloseDTO = class PackCloseDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.PackCloseDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "path", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, decorators_1.Describe)('Offer shown to the user'),
    __metadata("design:type", String)
], PackCloseDTO.prototype, "path", void 0);
PackCloseDTO = __decorate([
    (0, decorators_1.Describe)('A user has closed the offered pack')
], PackCloseDTO);
exports.PackCloseDTO = PackCloseDTO;
let PackSignupClickDTO = class PackSignupClickDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.PackSignupClickDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "loginMethod", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "path", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, decorators_1.Describe)('Login method used by the user'),
    __metadata("design:type", String)
], PackSignupClickDTO.prototype, "loginMethod", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, decorators_1.Describe)('Offer shown to the user'),
    __metadata("design:type", String)
], PackSignupClickDTO.prototype, "path", void 0);
PackSignupClickDTO = __decorate([
    (0, decorators_1.Describe)('A user has clicked signup from the offered pack')
], PackSignupClickDTO);
exports.PackSignupClickDTO = PackSignupClickDTO;
